<template>
  <div class="page">
    <div class="app-container">
      <el-button type="primary" size="mini" @click="add"
        >新增一级机构</el-button
      >
      <BaseTable
        ref="baseTable"
        url="/admin/org/index"
        :tableData.sync="tableData"
        :columns="columns"
        :searchParams="searchData"
        rowKey="id"
        align="left"
      >
        <template #custom="{ scope }">
          {{ scope.row.title }}
        </template>
        <template #handle="{ row }">
          <el-button type="text" size="mini" @click="edit(row)">编辑</el-button>
          <el-button type="text" size="mini" @click="addChildren(row)"
            >新增下级</el-button
          >
          <el-button type="text" size="mini" @click="del(row)">删除</el-button>
        </template>
      </BaseTable>

      <el-drawer title="机构" :visible.sync="isShowDrawer" direction="rtl">
        <div style="padding: 40px">
          <el-form
            ref="baseForm"
            :model="formData"
            :rules="rules"
            labelWidth="100px"
            size="medium"
          >
            <el-form-item
              label="上级机构"
              prop="pid"
              v-show="this.formData.pid"
            >
              <el-cascader
                v-model="formData.pid"
                :options="tableData"
                filterable
                change-on-select
                @change="handlePidChange"
                :props="{
                  value: 'id',
                  label: 'orgName',
                  emitPath: false,
                }"
                
              ></el-cascader>
            </el-form-item>

            <el-form-item label="机构名称" prop="orgName">
              <el-input v-model="formData.orgName" required></el-input>
            </el-form-item>
            <el-form-item label="机构编号" prop="orgNo">
              <el-input v-model="formData.orgNo"></el-input>
            </el-form-item>
            <el-form-item label="负责人" prop="leader">
              <el-input v-model="formData.leader"></el-input>
            </el-form-item>
            <el-form-item label="联系电话" prop="tel">
              <el-input v-model="formData.tel"></el-input>
            </el-form-item>
            <el-form-item label="地址" prop="addr">
              <el-input v-model="formData.addr"></el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="onSubmit">保存</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-drawer>
    </div>
  </div>
</template>

<script>
import { columns, rules } from "./columns";
export default {
  name: "Organization",
  comments: {},
  data() {
    return {
      tableData: [],
      searchData: {},
      isShowDrawer: false,
      formData: {
        pid: 0,
      },
      showPid: true,
    };
  },
  computed: {
    columns,
    rules,
  },
  created() {},
  methods: {
    add() {
      this.formData = {
        pid: 0,
      };
      this.showPid = false;
      this.isShowDrawer = true;
    },

    addChildren(row) {
      this.formData = {
        pid: row.id,
      };
      this.showPid = false;
      this.isShowDrawer = true;
    },

    edit(row) {
      this.formData = {
        id: row.id,
        orgNo: row.orgNo,
        orgName: row.orgName,
        leader: row.leader,
        tel: row.tel,
        addr: row.addr,
        pid: row.pid,
      };
      this.showPid = true;
      this.isShowDrawer = true;
    },

    del(row) {
      this.$confirm("是否确认删除该关系人信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await this.$api.post(
            "/admin/org/del",
            {
              id: row.id,
            },
            "删除"
          );
          this.$refs.baseTable.searchData();
          this.handleSearch();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },

    onSubmit() {
      this.$refs.baseForm.validate((validate) => {
        if (validate) {
          console.log(this.formData);
          this.$confirm("是否确认提交, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(async () => {
              await this.$api.post("/admin/org/save", this.formData, "更新");
              this.isShowDrawer = false;
              this.handleSearch();
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消操作",
              });
            });
        }
      });
      // this.$api
      //     .post("/admin/org/save", this.formData, "更新")
      //     .then(() => {
      //         this.isShowDrawer = false;
      //         this.$refs.baseTable.searchData();
      //     });
    },

    // 点击搜索
    handleSearch() {
      console.log(this.searchData);
      this.$refs.baseTable.searchData();
    },
    // 搜索参数拦截
    paramsCepCallback(params) {
      console.log(params);
      return {
        ...params,
        ...this.searchData,
      };
    },

    handlePidChange(value) {
      console.log(value);
      if (value.length) {
        this.formData.pid = value;
      }
    },
  },
};
</script>
